export default {
  your: '您的',
  save: '保存',
  reset: '取消',
  editinfo: '编辑',
  header1: '欢迎回到泛函',
  header2: '用户等级',
  header3: '累计泛函币',
  nav: {
    settings: '设置',
    profile: '个人档案',
    accountset: '账号设置',
    real: '实名认证',
    skill: '荣誉勋章',
    checkin: '每日签到',
    invite: '邀请注册'
  },
  profile: {
    username: '您的名字',
    uploadavatar: '上传新头像',
    sex: '性别',
    male: '男',
    female: '女',
    birthday: '生日',
    location: '地区',
    nationality: '国籍',
    ethnicity: '种族',
    whiteperson: '白种人',
    yellowperson: '黄种人',
    blackperson: '黑种人',
    marriage: '婚姻状态',
    unmarry: '未婚',
    married: '已婚',
    monthertonue: '母语',
    education: '学历',
    juniorschool: '初中',
    highschool: '高中',
    juniorcollege: '大专',
    regularcollege: '本科',
    graduatestudent: '硕士',
    doctor: '博士',
    workStatus: '职业状态',
    oc1: '在职',
    oc2: '学生',
    oc3: '待业',
    oc4: '自由职业',
    oc5: '全职妈妈',
    oc6: '退休',
    industry: '行业',
    industry0: '无',
    industry1: '互联网/IT/电子/通信',
    industry2: '广告/传媒/文化/体育',
    industry3: '金融/保险',
    industry4: '教育/培训',
    industry5: '交通/物流',
    industry6: '制药/医疗',
    industry7: '房地产/建筑',
    industry8: '贸易/零售',
    industry9: '建材/家居',
    industry10: '机械/制造',
    industry11: '汽车',
    industry12: '服务业',
    industry13: '专业服务',
    industry14: '能源/化工/环保',
    industry15: '政府/非盈利机构',
    industry16: '其他',
    interest: '兴趣爱好',
    interest1: '运动',
    interest2: '音乐',
    interest3: '乐器',
    interest4: '影视',
    interest5: '动漫',
    interest6: '阅读',
    interest7: '游戏',
    interest8: '旅游',
    interest9: '其他',
    js: {
      pleaseselect: '请选择',
      error: {
        type1: '失败',
        type2: '上传头像图片只能是 JPG 格式!',
        type3: '上传头像图片大小不能超过 2MB!'
      },
      success: '成功'
    }
  },
  account: {
    password: '密码',
    pwdchange: '更改密码',
    bind: '绑定',
    unbind: '未绑定',
    change: '更改',
    changephone: '更改绑定手机',
    changemail: '更改绑定邮箱',
    associate: '关联',
    associated: '已关联',
    unassociated: '未关联',
    developing: '开发中',
    accountSet0: '建议密码长度超过8位保证账号安全',
    accountSet2: '注销账号',
    accountSet3: '您的一切账号信息将从平台上删除',
    accountSet4: '注销',
    accountSet5: '账号关联',
    accountSet6: '支付绑定'
  },
  real_from: {
    realname: '实名认证',
    truename: '真实姓名',
    idcrdnum: '身份证号',
    idcardfront: '身份证头像、姓名面照片',
    idcardback: '身份证有效期信息面照片',
    idcardhold: '身份证照',
    idcard: '身份证',
    idcard2: '身份证正面（肖像面）',
    idcard3: '身份证背面（国徽面）',
    passport: '护照',
    company: '企业认证',
    passportNum: '护照号码',
    passportImg: '护照首页照片',
    passport2: '护照肖像面',
    company1: '法人姓名',
    company2: '法人身份证号',
    company3: '法人身份证照片',
    company4: '统一社会信用代码',
    company5: '企业营业执照',
    company6: '开户行账号',
    company7: '开户行许可证',
    submit: '提交审核',
    js: {
      rules: {
        realName: '请输入正确的姓名',
        idCardNum1: '请输入正确身份证号',
        idCardNum2: '最小长度15，最大长度18',
        idCardFront: '请上传身份证头像姓名面照片',
        idCardBack: '请上传身份证有效信息面照片',
        idCardHold: '请上传手持身份证头像、姓名面照片',
        passportNum: '请填写护照号',
        passportFront: '请上传护照照片'
      },
      error: {
        type1: '失败',
        type2: '上传头像图片只能是 JPG 格式!',
        type3: '上传头像图片大小不能超过 50MB!'
      },
      success: '成功'
    },
    payAccount7: '支付方式绑定',
    payAccount8: '支付宝账户'
  },
  real: {
    realname: '实名认证',
    reform: '重新认证',
    truename: '真实姓名：',
    idcardnum: '身份证号：',
    passportNum: '护照号码：',
    status: '认证审核状态：',
    js: {
      realStatus1: '审核中',
      realStatus2: '您已经通过了实名认证！',
      realStatus3: '审核未通过'
    },
    realShow0: '拒绝原因',
    realShow2: '法定代表人姓名',
    realShow3: '法定代表人身份证号'
  },
  skill: {
    language: '擅长语言',
    skillshow: '技能展示',
    skill1: '全部',
    skill2: '已获得',
    skill3: '查看勋章详情',
    skill4: '去获取勋章',
    skill5: '开始考试',
    skill6: '我的勋章墙'
  },
  checkIn: {
    str1: '连续签到',
    str2: '今日已领',
    str3: '第一天',
    day2: '第二天',
    day3: '第三天',
    day4: '第四天',
    day6: '第六天',
    day7: '第七天',
    str4: '第五天',
    str5: '点击签到',
    str6: '连续签到一周，获得丰厚泛函币奖励',
    str7: '签到规则',
    str8: '连续签到，7天为一周期',
    str9: '如签到中断，将按照新一周期重新开始',
    str10: '本次活动和设备生产商无关'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/user.js